import { Outlet, Navigate } from 'react-router-dom';

import { useAppState } from 'src/state';
import useCheckOnboarding from 'src/app/hooks/use-check-onboarding';
import { routes } from 'src/app/routes/constants';
import useConfig from 'src/app/config';

import Loading from 'src/app/ui/components/molecules/loading';
import ErrorComponent from 'src/app/ui/components/molecules/error';

export const ProtectedRoute = () => {
  const { config } = useConfig();

  const { isOnboardStatusLoaded, error } = useCheckOnboarding();
  const signedIn = useAppState(({ auth }) => auth.signedIn);
  const signoutTriggerBy = useAppState(({ auth }) => auth.signoutTriggerBy);

  const ssoEnabled = config.REACT_APP_SSO_ENABLED;

  if (!signedIn) {
    if (ssoEnabled) {
      const redirectTo = `${window.location.origin}/portal-authorization`;
      const ssoUrl = new URL(config.REACT_APP_SSO_REDIRECT_URL);

      if (signoutTriggerBy === 'user') {
        window.location.replace(ssoUrl.origin);
      } else {
        ssoUrl.searchParams.set('redirect_to', redirectTo);
        window.location.replace(ssoUrl.toString());
      }
      return <Loading />;
    }
    return <Navigate to={routes.SIGNIN} />;
  }

  if (!isOnboardStatusLoaded) {
    return <Loading />;
  }

  if (error) {
    return <ErrorComponent />;
  }

  return <Outlet />;
};
